import type { AppItem } from '@/lib/types/marketplace'
import apiClient from "@/lib/api/client";
import API from "@/api/API";

interface MarketplaceListResponse {
  success: boolean
  total: number
  results: AppItem[]
}

export const marketplaceApi = {
  list: async (params?: { q?: string; category?: string }) => {
    const response = await apiClient.get<MarketplaceListResponse | AppItem[]>(API.marketplace.list, { params })
    const data = response.data
    // 兼容两种后端契约：
    //  - 新版：{ success, total, results }
    //  - 旧版：裸数组（历史 bundle / 回滚时）
    if (Array.isArray(data)) return data
    if (data && Array.isArray((data as MarketplaceListResponse).results)) {
      return (data as MarketplaceListResponse).results
    }
    return []
  },
}
